// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { useNavigate } from "react-router-dom";
// import { FaEdit } from "react-icons/fa";
// import { jwtDecode } from "jwt-decode";
// import { NotificationManager } from 'react-notifications';


// const NAV_BASE_URL = process.env.REACT_APP_NAV_BASE_URL;
// const NAV_API_KEY = process.env.REACT_APP_NAV_API_KEY;

// const NavManagement = () => {
//   const [date, setDate] = useState(new Date());
//   const [responseData, setResponseData] = useState([]); // Initialize as empty array
//   const [responseAllData, setAllResponseData ] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [navNotFoundError, setNavNotFoundError] = useState(false);
//   const [newNav, setNewNav] = useState("");
//   const [updateNavDate, setUpdateNavDate] = useState(new Date());
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [showModal, setShowModal] = useState(false);
//   const [adminName, setAdminName] = useState(null); 

//   const navigate = useNavigate();

//   const BaseUrl = process.env.REACT_APP_BASE_URL;

//   useEffect(() => {
//     const validateToken = async () => {
//       try {
//         const jwtToken = localStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in local storage");
//         }

//         const response = await axios.post(`${BaseUrl}/validate-token`, {
//           token: jwtToken,
//         });
//         if (!response.data.valid) {
//           throw new Error("Token validation failed");
//         }
//          // Decode the JWT token to get admin_id
//          const decodedToken = jwtDecode(jwtToken);
//          const adminNameFromToken = decodedToken.name; // Assuming admin_id is in the token
//          setAdminName(adminNameFromToken); // Store the admin_id in state

//       } catch (error) {
//         console.error("Error validating token:", error);
//         navigate("/login");
//         localStorage.removeItem("authToken");
//       }
//     };

//     validateToken();
//   }, [navigate]);

//   const fetchNavHistory = async () => {
//     try {
//       setLoading(true);
//       setError("");
//       setNavNotFoundError(false);
//       const response = await axios.get(`${NAV_BASE_URL}/nav-history`, {
//         headers: {
//           Authorization: `${NAV_API_KEY}`,
//         },
//       });

//       if (response.data && response.data.data && response.data.data.length > 0) {
//         const sortedNavData = response.data.data.sort((a, b) => {
//           const dateA = new Date(a.nav_date);
//           const dateB = new Date(b.nav_date);
//           return dateB - dateA;
//         });

//         setAllResponseData(sortedNavData);
//         const selectedDateNav = sortedNavData.find(
//           (nav) => new Date(nav.nav_date).toLocaleDateString() === date.toLocaleDateString()
//         );

//         if (selectedDateNav) {
//           setResponseData([selectedDateNav]); // Only set the selected NAV
//         } else {
//           setNavNotFoundError(true);
//           setResponseData([]); // Ensure it's an empty array if not found
//         }
//       } else {
//         setResponseData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching NAV history:", err);
//       setError("Error fetching NAV history. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateNav = async () => {
//     if (!newNav || isNaN(newNav) || newNav <= 0) {
//       return setError("Invalid NAV value.");
//     }

//     try {
//       setLoading(true);
//       const formattedDate = updateNavDate.toISOString().split("T")[0];
//       await axios.post(
//         `${NAV_BASE_URL}/update-nav`,
//         {
//           navPrice: newNav,
//           navDate: formattedDate,
//           adminName:adminName
//         },
//         {
//           headers: {
//             Authorization: `${NAV_API_KEY}`,
//           },
//         }
//       );
//       NotificationManager.success("The NAV has been updated successfully.")
//       setNewNav("");
//       setShowModal(false);
//       fetchNavHistory();
//     } catch (err) {
//       console.error("Error updating NAV:", err);
//       setError("Failed to update NAV. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchNavHistory();
//   }, []);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentNavData = responseAllData.slice(indexOfFirstItem, indexOfLastItem);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const handleNavDateClick = (navDate) => {
//     setUpdateNavDate(new Date(navDate));
//     const updateNavSection = document.getElementById("update-nav-section");
//     if (updateNavSection) {
//       updateNavSection.scrollIntoView({ behavior: "smooth", block: "start" });
//     }
//   };

//   const handleEditNav = (nav) => {
//     setUpdateNavDate(new Date(nav.nav_date));
//     setNewNav(nav.current_nav);
//     setShowModal(true); 
//     // const updateNavSection = document.getElementById("update-nav-section");
//     // if (updateNavSection) {
//     //   updateNavSection.scrollIntoView({ behavior: "smooth", block: "start" });
//     // }
//   };

//   // Utility function to format date
// const formatDate = (date) => {
//   if (!date) return '';
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0'); 
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// }

//   return (
//     <div className="container">
//   <div className="row justify-content-center">
//     <div className="col-11">
//     <div className="cont">
//       <div className="admin-management">
//         <h3 style={{textAlign: 'center',  marginBottom:"10px", fontWeight:'bold'}}>NAV MANAGEMENT</h3>
//         <section
//           style={{
//             marginBottom: "20px",
//             padding: "20px",
//             border: "1px solid #ccc",
//             borderRadius: "8px",
//             backgroundColor: "#f9f9f9",
//           }}
//         >
//           <h4 style={{ textAlign: "center" }}>Current NAV</h4>
//           <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
//             <div
//               style={{
//                 flex: "1",
//                 padding: "10px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 backgroundColor: "#f9f9f9",
//               }}
//             >
//               <h4>Select Date</h4>
//               <div style={{ marginTop: "10px" }}>
//                 <DatePicker
//                   id="date-picker"
//                   selected={date}
//                   onChange={(date) => setDate(date)}
//                   dateFormat="dd-MM-yyyy"
//                   className="form-control"
//                 />
//               </div>
//             </div>

//             <div
//               style={{
//                 flex: "1",
//                 padding: "10px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 backgroundColor: "#f9f9f9",
//               }}
//             >
//               <h4>Current NAV</h4>
//               {responseData.length > 0 ? (
//                 <div style={{ marginTop: "10px" }}>
//                   <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>
//                     ${responseData[0].current_nav}
//                   </h2>
//                 </div>
//               ) : (
//                 <div style={{ marginTop: "10px" }}>
//                   {navNotFoundError ? (
//                     <h4>Nav not found for selected date.</h4>
//                   ) : (
//                     <h4>Loading...</h4>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>

//           <button
//             onClick={fetchNavHistory}
//             className="btn btn-primary"
//             style={{ marginTop: "20px" }}
//             disabled={loading}
//           >
//             {loading ? "Loading..." : "Fetch NAV"}
//           </button>
//         </section>

//         {/* <section
//           style={{
//             padding: "20px",
//             border: "1px solid #ccc",
//             borderRadius: "8px",
//             backgroundColor: "#f9f9f9",
//           }}
//           id="update-nav-section"
//         >
//           <h4 style={{ textAlign: "center" }}>Update NAV</h4>
//           <div style={{ marginTop: "10px" }}>
//             <div
//               style={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: "10px",
//                 alignItems: "center",
//               }}
//             >
//               <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1", minWidth: "200px" }}>
//                 <label htmlFor="date-picker" style={{ whiteSpace: "nowrap" }}>
//                   Select Date:
//                 </label>
//                 <DatePicker
//                   id="date-picker"
//                   selected={updateNavDate}
//                   onChange={(date) => setUpdateNavDate(date)}
//                   dateFormat="yyyy-MM-dd"
//                   className="form-control"
//                   style={{ width: "150px" }}
//                 />
//               </div>

//               <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1", minWidth: "200px" }}>
//                 <label htmlFor="new-nav" style={{ whiteSpace: "nowrap" }}>
//                   Enter New NAV:
//                 </label>
//                 <input
//                   type="number"
//                   id="new-nav"
//                   value={newNav}
//                   onChange={(e) => setNewNav(e.target.value)}
//                   className="form-control"
//                   style={{ width: "180px", height: "35px" }}
//                 />
//               </div>
//             </div>
//             <button
//               onClick={updateNav}
//               className="btn btn-primary"
//               style={{ marginTop: "10px" }}
//               disabled={loading}
//             >
//               {loading ? "Updating..." : "Update NAV"}
//             </button>
//           </div>
//         </section> */}
//         {/* Update NAV Modal */}
//         {showModal && (
//           <div className="modal show d-block" tabIndex="-1">
//             <div className="modal-dialog">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h5 className="modal-title">Update NAV</h5>
//                   <button
//                     type="button"
//                     className="btn-close"
//                     onClick={() => setShowModal(false)}
//                   ></button>
//                 </div>
//                 <div className="modal-body">
//                   <form>
//                     <div className="mb-3">
//                       <label htmlFor="navDate" className="form-label">
//                         NAV Date
//                       </label>
//                       {/* <DatePicker
//                         selected={updateNavDate}
//                         onChange={(date) => setUpdateNavDate(date)}
//                         className="form-control"
//                         id="navDate"
//                       /> */}
//                        <DatePicker
//                 selected={updateNavDate}
//                 onChange={(date) => setUpdateNavDate(date)}
//                 className="form-control"
//                 id="navDate"
//                 dateFormat="dd-MM-yyyy" // Internal formatting for DatePicker
//                 value={formatDate(updateNavDate)} // Format the displayed value
//               />
//                     </div>
//                     <div className="mb-3">
//                       <label htmlFor="navPrice" className="form-label">
//                         NAV Price
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         id="navPrice"
//                         value={newNav}
//                         onChange={(e) => setNewNav(e.target.value)}
//                       />
//                     </div>
//                   </form>
//                 </div>
//                 <div className="modal-footer">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={() => setShowModal(false)}
//                   >
//                     Close
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={updateNav}
//                   >
//                     Update
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//         <section
//           style={{
//             marginTop: "20px",
//             padding: "20px",
//             border: "1px solid #ccc",
//             borderRadius: "8px",
//             backgroundColor: "#f9f9f9",
//           }}
//         >
//           <h4 style={{ textAlign: "center" }}>NAV History</h4>
//           <table className="table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Price</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentNavData.map((nav, index) => (
//                 <tr key={index} onClick={() => handleNavDateClick(nav.nav_date)}>
//                 <td>{new Date(nav.nav_date).toLocaleDateString('en-GB')}</td>
//                 <td>${nav.current_nav}</td>
//                   <td>
//                   <button
//                     className="btn btn-link"
//                     onClick={() => handleEditNav(nav)}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <FaEdit />
//                   </button>
//                 </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {/* Pagination */}
//           <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
//             {Array.from({ length: Math.ceil(responseAllData.length / itemsPerPage) }, (_, index) => (
//               <button
//                 key={index + 1}
//                 onClick={() => paginate(index + 1)}
//                 className={`btn btn-pagination ${currentPage === index + 1 ? "active" : ""}`}
//                 style={{ margin: "0 5px" }}
//               >
//                 {index + 1}
//               </button>
//             ))}
//           </div>
//         </section>
//       </div>
//     </div>
//     </div>
//     </div>
//     </div>
//   );
// };

// export default NavManagement;


import React, { useEffect, useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import { NotificationManager } from 'react-notifications';


const NAV_BASE_URL = process.env.REACT_APP_NAV_BASE_URL;
const NAV_API_KEY = process.env.REACT_APP_NAV_API_KEY;

const NavManagement = () => {
  const [date, setDate] = useState(new Date());
  const [responseData, setResponseData] = useState([]); // Initialize as empty array
  const [responseAllData, setAllResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [navNotFoundError, setNavNotFoundError] = useState(false);
  const [newNav, setNewNav] = useState("");
  const [updateNavDate, setUpdateNavDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [adminName, setAdminName] = useState(null); 

  const navigate = useNavigate();

  const BaseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const validateToken = async () => {
      try {
        const jwtToken = localStorage.getItem("authToken");
        if (!jwtToken) {
          throw new Error("JWT token not found in local storage");
        }

        const response = await axios.post(`${BaseUrl}/validate-token`, {
          token: jwtToken,
        });
        if (!response.data.valid) {
          throw new Error("Token validation failed");
        }
         // Decode the JWT token to get admin_id
         const decodedToken = jwtDecode(jwtToken);
         const adminNameFromToken = decodedToken.name; // Assuming admin_id is in the token
         setAdminName(adminNameFromToken); // Store the admin_id in state

      } catch (error) {
        console.error("Error validating token:", error);
        navigate("/login");
        localStorage.removeItem("authToken");
      }
    };

    validateToken();
  }, [navigate]);

  const fetchNavHistory = async () => {
    try {
      setLoading(true);
      setError("");
      setNavNotFoundError(false);
      const response = await axios.get(`${NAV_BASE_URL}/nav-history`, {
        headers: {
          Authorization: `${NAV_API_KEY}`,
        },
      });

      if (response.data && response.data.data && response.data.data.length > 0) {
        const sortedNavData = response.data.data.sort((a, b) => {
          const dateA = new Date(a.nav_date);
          const dateB = new Date(b.nav_date);
          return dateB - dateA;
        });

        setAllResponseData(sortedNavData);
        const selectedDateNav = sortedNavData.find(
          (nav) => new Date(nav.nav_date).toLocaleDateString() === date.toLocaleDateString()
        );

        if (selectedDateNav) {
          setResponseData([selectedDateNav]); // Only set the selected NAV
        } else {
          setNavNotFoundError(true);
          setResponseData([]); // Ensure it's an empty array if not found
        }
      } else {
        setResponseData([]);
      }
    } catch (err) {
      console.error("Error fetching NAV history:", err);
      setError("Error fetching NAV history. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const updateNav = async () => {
    if (!newNav || isNaN(newNav) || newNav <= 0) {
      return setError("Invalid NAV value.");
    }

    try {
      setLoading(true);
      const formattedDate = updateNavDate.toISOString().split("T")[0];
      await axios.post(
        `${NAV_BASE_URL}/update-nav`,
        {
          navPrice: newNav,
          navDate: formattedDate,
          adminName:adminName
        },
        {
          headers: {
            Authorization: `${NAV_API_KEY}`,
          },
        }
      );
      NotificationManager.success("The NAV has been updated successfully.")
      setNewNav("");
      setShowModal(false);
      fetchNavHistory();
    } catch (err) {
      console.error("Error updating NAV:", err);
      setError("Failed to update NAV. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNavHistory();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNavData = responseAllData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(responseAllData.length / itemsPerPage);

  // Generate page numbers for pagination with ellipsis
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = window.innerWidth < 768 ? 3 : 5; // Responsive based on screen width

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total pages are less than max visible
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(1);

      // Calculate start and end of visible pages
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Adjust if we're at the beginning
      if (currentPage <= 2) {
        endPage = Math.min(totalPages - 1, maxVisiblePages - 1);
      }

      // Adjust if we're at the end
      if (currentPage >= totalPages - 1) {
        startPage = Math.max(2, totalPages - (maxVisiblePages - 2));
      }

      // Add ellipsis after first page if needed
      if (startPage > 2) {
        pageNumbers.push('...');
      }

      // Add visible page numbers
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        pageNumbers.push('...');
      }

      // Always show last page if there's more than one page
      if (totalPages > 1) {
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers;
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages && pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
    }
  };

  const handleNavDateClick = (navDate) => {
    setUpdateNavDate(new Date(navDate));
    const updateNavSection = document.getElementById("update-nav-section");
    if (updateNavSection) {
      updateNavSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleEditNav = (nav) => {
    setUpdateNavDate(new Date(nav.nav_date));
    setNewNav(nav.current_nav);
    setShowModal(true); 
  };

  // Utility function to format date
  const formatDate = (date) => {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Make table responsive
  const tableContainerStyle = {
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
    marginBottom: '20px'
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <div className="cont">
            <div className="admin-management">
              <h3 style={{textAlign: 'center',  marginBottom:"10px", fontWeight:'bold'}}>NAV MANAGEMENT</h3>
              
              <section
                style={{
                  marginBottom: "20px",
                  padding: "20px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <h4 style={{ textAlign: "center" }}>Current NAV</h4>
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <div className="p-3 border rounded bg-light">
                      <h4>Select Date</h4>
                      <div className="mt-2">
                        <DatePicker
                          id="date-picker"
                          selected={date}
                          onChange={(date) => setDate(date)}
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-12 col-md-6">
                    <div className="p-3 border rounded bg-light">
                      <h4>Current NAV</h4>
                      {responseData.length > 0 ? (
                        <div className="mt-2">
                          <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>
                            ${responseData[0].current_nav}
                          </h2>
                        </div>
                      ) : (
                        <div className="mt-2">
                          {navNotFoundError ? (
                            <h4>Nav not found for selected date.</h4>
                          ) : (
                            <h4>Loading...</h4>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  onClick={fetchNavHistory}
                  className="btn btn-primary mt-3"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Fetch NAV"}
                </button>
              </section>

              {/* Update NAV Modal */}
              {showModal && (
                <div className="modal show d-block" tabIndex="-1">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Update NAV</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="mb-3">
                            <label htmlFor="navDate" className="form-label">
                              NAV Date
                            </label>
                            <DatePicker
                              selected={updateNavDate}
                              onChange={(date) => setUpdateNavDate(date)}
                              className="form-control"
                              id="navDate"
                              dateFormat="dd-MM-yyyy"
                              value={formatDate(updateNavDate)}
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="navPrice" className="form-label">
                              NAV Price
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="navPrice"
                              value={newNav}
                              onChange={(e) => setNewNav(e.target.value)}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowModal(false)}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={updateNav}
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <section
                style={{
                  marginTop: "20px",
                  padding: "20px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <h4 style={{ textAlign: "center" }}>NAV History</h4>
                
                {/* Responsive table container */}
                <div style={tableContainerStyle}>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentNavData.map((nav, index) => (
                        <tr key={index} onClick={() => handleNavDateClick(nav.nav_date)} style={{ cursor: 'pointer' }}>
                          <td>{new Date(nav.nav_date).toLocaleDateString('en-GB')}</td>
                          <td>${nav.current_nav}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditNav(nav);
                              }}
                              title="Edit NAV"
                            >
                              <FaEdit />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Responsive Pagination */}
                {totalPages > 0 && (
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
                    <div className="mb-2 mb-md-0">
                      <p className="mb-0">
                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, responseAllData.length)} of {responseAllData.length} entries
                      </p>
                    </div>
                    
                    <nav aria-label="NAV History Pagination">
                      <ul className="pagination justify-content-center mb-0">
                        {/* Previous button */}
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            aria-label="Previous"
                          >
                            <FaChevronLeft />
                          </button>
                        </li>

                        {/* Page numbers */}
                        {getPageNumbers().map((pageNumber, index) => (
                          <li 
                            key={index} 
                            className={`page-item ${pageNumber === '...' ? 'disabled' : ''} ${pageNumber === currentPage ? 'active' : ''}`}
                          >
                            {pageNumber === '...' ? (
                              <span className="page-link">...</span>
                            ) : (
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            )}
                          </li>
                        ))}

                        {/* Next button */}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            aria-label="Next"
                          >
                            <FaChevronRight />
                          </button>
                        </li>
                      </ul>
                    </nav>

                    {/* Mobile-friendly page selector */}
                    <div className="d-md-none d-flex align-items-center mt-2">
                      <select
                        className="form-select form-select-sm"
                        value={currentPage}
                        onChange={(e) => handlePageChange(parseInt(e.target.value))}
                        style={{ width: 'auto' }}
                      >
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                          <option key={page} value={page}>
                            Page {page}
                          </option>
                        ))}
                      </select>
                      <span className="ms-2">of {totalPages}</span>
                    </div>
                  </div>
                )}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavManagement;